<template>
	<div class="modal-wrapper password-confirm">
		<div class="modal-container">
			<div class="modal-close text-primary" @click="onClose">
				&times;
			</div>
			<SVGIcon icon-name="email-update-confirmation" width="140" height="140" fill="none" class="mt-65" />

			<div class="flex flex-col content">
				<div class="flex justify-center title">
					{{ $t('modals.userPasswordConfirm.title') }}
				</div>
				<div class="flex text">
					{{ $t('modals.userPasswordConfirm.text') }}
				</div>
				<div class="flex w-full justify-center">
					<ValidationObserver v-slot="{ passes, invalid }" tag="form" class="w-full items-center flex flex-col" @submit.prevent>
						<TextInput
							v-model="password"
							:label="$t('labels.password', { character: '' })"
							:placeholder="$t('labels.enterPasswordPlaceholder')"
							name="password"
							rules="required|min:8"
							type="password"
							vid="pass"
						/>
						<button :disabled="loading || invalid" class="button-light-blue" @click="passes(save)">
							{{ $tc('actions.confirm') }}
						</button>
					</ValidationObserver>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ValidationObserver } from 'vee-validate'
import SVGIcon from '~/components/interface/SVGIcon'
import TextInput from '~/components/interface/TextInput'
import { ModalMixin } from '~/assets/vue/mixins'

export default {
	name: 'ModalUserPasswordConfirm',
	components: {
		SVGIcon,
		TextInput,
		ValidationObserver
	},
	mixins: [ModalMixin],
	data () {
		return {
			password: '',
			loading: false
		}
	},
	computed: {
		...mapGetters({ user: 'user/user' })
	},
	methods: {
		...mapActions({ reauthenticateUser: 'auth/reauthenticateUser' }),
		save () {
			this.loading = true
			this.reauthenticateUser(this.password).then(this.onConfirm).catch(this.onError)
		},
		onError (error) {
			const message = error && error.message
			this.loading = false

			this.$toast.error(message || this.$tc('errors.fetchError'))
		}
	}
}
</script>

<style lang="scss">
.password-confirm {
	.modal-container {
		width: 371px;
		height: 590px;
		margin: 0px auto;
		background-color: #fff;
		border-radius: 2px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
		transition: all 0.3s ease;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.modal-close {
		position: absolute;
		right: 10px;
		font-size: 24px;
		cursor: pointer;
		color: #000000;
	}

	.title {
		font-family: 'Rubik', sans-serif;
		font-size: 32px;
		font-weight: 500;
	}

	.content {
		padding: 32px;
	}

	.text {
		font-size: 16px;
		font-weight: 400;
		padding: 13px 0 32px 0;
	}

	.text-input-wrap {
		width: 100%;

		input {
			border: 1px solid #B8B8B8;
			background: #F3F4F4;
		}
	}
	button {
		max-width: 160px;
		margin-top: 32px;
	}
}
</style>
